export default __webpack_public_path__ + "static/media/insurancemenuicon.e0e4075f.svg";